/**
 * The guide identifiers of `OpenAiFileIdentifier` (schema.prisma). A guide is managed as source code
 * in the API, auto-included in every model of its chat type, and never edited here. One list, so the
 * upload, detail and edit pages cannot disagree about which identifiers are guides.
 *
 * CLE-3043 added HospitalStaffGuide (auto-included for ContractManagementBot models, next to
 * ContractManagementGuide).
 */
export const GUIDE_FILE_IDENTIFIERS = [
  "EligibilityProcessingGuide",
  "PricingAdjustmentsGuide",
  "ContractManagementGuide",
  "HospitalStaffGuide",
] as const;

export type GuideFileIdentifier = (typeof GUIDE_FILE_IDENTIFIERS)[number];

export const isGuideFileIdentifier = (
  identifier: string | null | undefined
): identifier is GuideFileIdentifier =>
  !!identifier &&
  (GUIDE_FILE_IDENTIFIERS as readonly string[]).includes(identifier);

/** The upload page's identifier dropdown. */
export const FILE_IDENTIFIER_OPTIONS: { label: string; value: string }[] = [
  {
    label: "Eligibility Business Rules Documentation",
    value: "EligibilityProcessingGuide",
  },
  {
    label: "Pricing Adjustment Business Rules Documentation",
    value: "PricingAdjustmentsGuide",
  },
  {
    label: "Contract Management Business Rules Documentation",
    value: "ContractManagementGuide",
  },
  { label: "Hospital Staff Guide", value: "HospitalStaffGuide" },
  { label: "Custom", value: "Custom" },
];

/** The newest uploaded file with this identifier — the one the API auto-includes. */
export const mostRecentFileWithIdentifier = <
  T extends { identifier: string; createdAt: string }
>(
  files: T[] | null | undefined,
  identifier: string
): T | undefined =>
  (files ?? [])
    .filter((file) => file.identifier === identifier)
    .sort(
      (a, b) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    )[0];
